import React from "react";
import { motion } from "framer-motion";

import { ProfileCircleProps } from "./ProfileCircle.types";

import "./ProfileCircle.scss";

const ProfileCircle: React.FC<ProfileCircleProps> = ({
  imageSource,
  onClick,
  initials,
  backgroundColor,
  size = 100,
}) => {
  const style =
    imageSource !== null ? { backgroundImage: `url('${imageSource}')` } : {};
  return (
    <div
      className="mp-molecules-profilecircle--main"
      style={{ width: size, height: size }}
    >
      <motion.div
        data-testid="profile-circle"
        className={`image-container${
          onClick === undefined ? "" : " clickable"
        }`}
        onClick={onClick}
        style={style}
        animate={{
          backgroundColor: backgroundColor || "#fff",
        }}
      >
        {initials && !imageSource && (
          <span style={{ fontSize: size / 3 }}>{initials}</span>
        )}
      </motion.div>
    </div>
  );
};

export default ProfileCircle;
